import { useGetCardLast4 } from "@/generated/open-api/subscription/subscription";

export const useGetParsedCardLast4 = () => {
  const { data, ...rest } = useGetCardLast4();
  return { data: data?.card_last4 ?? null, ...rest };
};
